import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {ToastrModule} from 'ngx-toastr';

import {AppComponent} from './app.component';
import {AdminLayoutComponent} from './layouts/admin-layout/admin-layout.component';

import {AppRoutingModule} from './app-routing.module';
import {ComponentsModule} from './components/components.module';

import {initializer} from './utils/app-init';
import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import {LoaderService} from './services/common/loader.service';
import {HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import {LoaderInterceptor} from './interceptors/loader.interceptor';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {Utilities} from './utils/utilities';
import {Constants} from './utils/constants';
import {DirectivesModule} from "./directives/directives.module";
import {MyStorageService} from "./services/common/my-storage.service";
import {NgStompSockModule} from "@oril/ng-stomp-sock";
import {environment} from "../environments/environment";
import {VgCoreModule} from "ngx-videogular";


@NgModule({
    declarations: [
        AppComponent,
        AdminLayoutComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        BrowserAnimationsModule,
        RouterModule,
        AppRoutingModule,
        ToastrModule.forRoot(),
        ComponentsModule,
        DirectivesModule,
        KeycloakAngularModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient, MyStorageService]
            }
        }),
        NgStompSockModule.config({
            url: environment.wsUrl
        }),
        VgCoreModule,
    ],
    providers: [
        LoaderService,
        {provide: Window, useValue: window},
        {provide: APP_INITIALIZER, useFactory: initializer, deps: [KeycloakService], multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true}
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}

export function httpTranslateLoader(http: HttpClient, myStorage: MyStorageService) {
    if (!myStorage.checkKey('turnOffTranslations')) {
        return new TranslateHttpLoader(http, Utilities.getTranslateUrl(), '/' + Constants.ENVIRONMENT);
    } else {
        return new TranslateHttpLoader(http, './assets/i18n/', '.json');
    }
}
